import I18n from 'i18n-js';
import React from 'react';
import HomepageCategories from '../homepage_categories';
import RQLHomepageFeed from '../../../feed/rql_homepage_feed';
import RegionalListings from '../regional_listings';
import { Paths } from '../../shared/url_helpers';
import DownloadAppCallout from './download_app_callout';
import HomepageSell from './homepage_sell';
import HomepageSellVisibilityV2 from './homepage_sell_visibility_v2';
import HomepageNewsletter from './homepage_newsletter';
import HomepageMosaic from './homepage_mosaic';
import RecentArticles from './recent_articles';
import { buyingGuideEligibleRegionAndLocale } from '../user_helper';
import RecentlyViewedCspsRow from '../../recently_viewed_csps_row';
import RecommendedListingsRow from '../../recommended_listings/recommended_listings_row';
import SiteBannerHeroContainer from '../site_banner_hero_container';
import HomepageDealsAndStealsListingsCollection from '../../homepage_deals_and_steals_listings_collection';

import CmsListingsCollection, { ADDITIONAL_SORTS } from '@reverbdotcom/commons/src/cms/components/cms_listings_collection';
import CmsPageCards, { CMS2_PAGE } from '@reverbdotcom/commons/src/cms/components/cms_page_cards';
import RecentlyViewedListings from '@reverbdotcom/commons/src/cms/components/recently_viewed_listings';
import WatchedListings from '@reverbdotcom/commons/src/components/watched_listings';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import CmsEmbed from '@reverbdotcom/commons/src/components/cms_embed';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';

export class LoggedInHomepage extends React.Component<IUserContext, any> {
  renderBuyingGuides() {
    if (buyingGuideEligibleRegionAndLocale(this.props.user.shippingRegionCode, this.props.user.locale)) {
      return (
        <div className="homepage-container__component-wrapper">
          <CmsPageCards
            title={I18n.t('discovery.homepage.buyingGuides.buyingGuidesHeading')}
            pageFields={[
              { pageSource: CMS2_PAGE, slug: 'buying-guide-acoustic-guitars' },
              { pageSource: CMS2_PAGE, slug: 'buying-guide-telecasters' },
              { pageSource: CMS2_PAGE, slug: 'buying-guide-audio-interfaces' },
              { pageSource: CMS2_PAGE, slug: 'buying-guide-gibson-les-pauls' },
              { pageSource: CMS2_PAGE, slug: 'buying-guide-affordable-monosynths' },
              { pageSource: CMS2_PAGE, slug: 'buying-guide-reverb-pedals' },
            ]}
            ssr={false}
            action={this.renderBuyingGuidesAction()}
          />
        </div>
      );
    }

    return <HomepageCategories />;
  }

  renderBuyingGuidesAction() {
    return (
      <CoreLink to={Paths.buyingGuide.expand({})}>
        {I18n.t('discovery.homepage.buyingGuides.seeMore')}
      </CoreLink>
    );
  }

  renderArticlesAction() {
    return (
      <CoreLink to={Paths.articlesSearch.expand({})}>
        {I18n.t('discovery.homepage.buyingGuides.seeMore')}
      </CoreLink>
    );
  }

  render() {
    return (
      <>
        <SiteBannerHeroContainer />
        <HomepageMosaic />
        <div className="homepage-container bg-white pt-half">
          <div className="homepage-container__component-wrapper">
            <RecentlyViewedCspsRow />
          </div>
          <div className="homepage-container__component-wrapper">
            <RecentlyViewedListings
              title={I18n.t('discovery.recentlyViewed.title')}
              largeTiles
              ctaTargetHref="/browsing_history"
            />
          </div>
          {isExperimentEnabled(this.props.user, experiments.HOMEPAGE_SELL_VISIBILITY_V3) &&
            <HomepageSellVisibilityV2 />
          }
          <div className="homepage-container__component-wrapper">
            <WatchedListings />
          </div>
          <div className="homepage-container__component-wrapper">
            <RecommendedListingsRow limit={12} />
          </div>
          <RQLHomepageFeed />
          <div className="homepage-container__component-wrapper">
            <CmsEmbed slug="homepage-embed" ssrMode="static-only" />
          </div>
          <div className="homepage-container__component-wrapper">
            <RecentArticles
              action={this.renderArticlesAction()}
            />
          </div>
          {this.renderBuyingGuides()}
          <div className="homepage-container__component-wrapper">
            <HomepageSell />
          </div>
          <RegionalListings />
          <div className="homepage-container__component-wrapper">
            <CmsListingsCollection
              componentName="HomepageLatestListings"
              ctaTargetHref="/marketplace?condition=used"
              conditionSlugs={['used']}
              title={I18n.t('discovery.homepage.newestListings.title')}
              userShippingRegion={this.props.user.shippingRegionCode}
              maxCount={12}
              largeTiles
              ssr={false}
            />
          </div>
          <div className="homepage-container__component-wrapper">
            <HomepageDealsAndStealsListingsCollection />
          </div>
          <div className="homepage-container__component-wrapper">
            <HomepageNewsletter signupReason="loggedinhomepage" />
          </div>
          <div className="homepage-container__component-wrapper">
            <CmsListingsCollection
              componentName="HomepageBumpedListings"
              title={I18n.t('discovery.bumpsView.promotedListings')}
              sort={ADDITIONAL_SORTS.BUMP_BOOST}
              ssr={false}
              maxCount={12}
              largeTiles
            />
          </div>
          <div className="scaling-mt-7">
            <DownloadAppCallout />
          </div>
        </div>
      </>
    );
  }
}

export default withUserContext(LoggedInHomepage);
